<div fxLayout="column" class="layout-padd" [ngStyle]="{'max-height.px': innerHeight}">

    <div fxLayoutAlign="center center" class="layout-padd text-center">

        <span class="mat-subheading-1">
            {{'confirmRechargeComponent.save' | translate}}
           
        </span>


    </div>


    <!-- button -->
    <div fxLayout="row" fxLayoutAlign="center center" class="layout-padd" fxLayoutGap="10px">

        <button fxFlex mat-stroked-button color="warn" (click)="savePayment('false')" angulartics2On="click"
            angularticsAction="cancelSavepayment">{{"button.no"|translate}}</button>
        <button fxFlex mat-stroked-button color="accent" (click)="savePayment('true')" angulartics2On="click"
            angularticsAction="savePayment">{{"button.yes"|translate}}</button>

    </div>

</div>


<app-popup-loader [flagLoading]="loader" [size]="30"></app-popup-loader>